import MunicipalityStore from '../stores/municipalityStore'

const municipalityStore = new MunicipalityStore()

export default municipalityStore
